/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbFormateurPrestationsGlobalesGridDtoPaginatedResults,
  FilterCriteriaInfo,
  FormateurPrestationsGlobalesSearch,
  SelectItem,
} from '../models/index';
import {
    FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsFromJSON,
    FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    FormateurPrestationsGlobalesSearchFromJSON,
    FormateurPrestationsGlobalesSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface FormateurPrestationsGlobalesBaseSearchRequest {
    FormateurPrestationsGlobalesSearch?: FormateurPrestationsGlobalesSearch;
}

export interface FormateurPrestationsGlobalesGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface FormateurPrestationsGlobalesGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class FormateurPrestationsGlobalesApi extends runtime.BaseAPI {

    /**
     */
    async formateurPrestationsGlobalesBaseSearchRaw(requestParameters: FormateurPrestationsGlobalesBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbFormateurPrestationsGlobalesGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurPrestationsGlobales/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormateurPrestationsGlobalesSearchToJSON(requestParameters.FormateurPrestationsGlobalesSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbFormateurPrestationsGlobalesGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async formateurPrestationsGlobalesBaseSearch(requestParameters: FormateurPrestationsGlobalesBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbFormateurPrestationsGlobalesGridDtoPaginatedResults> {
        const response = await this.formateurPrestationsGlobalesBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurPrestationsGlobalesGetSearchCriteriasRaw(requestParameters: FormateurPrestationsGlobalesGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurPrestationsGlobales/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async formateurPrestationsGlobalesGetSearchCriterias(requestParameters: FormateurPrestationsGlobalesGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.formateurPrestationsGlobalesGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurPrestationsGlobalesGetSelectItemsRaw(requestParameters: FormateurPrestationsGlobalesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling formateurPrestationsGlobalesGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurPrestationsGlobales/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async formateurPrestationsGlobalesGetSelectItems(requestParameters: FormateurPrestationsGlobalesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.formateurPrestationsGlobalesGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
